export default __webpack_public_path__ + "static/media/user-alt-solid.ed9f4794.svg";